import type { FC } from "react";

import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import BoxTitle from "pro-features/components/BoxTitle/src/BoxTitle";

interface IFixedBoxTitle {
    title: string;
    tooltip?: string;
}

const { carbon } = colorsPalettes;

const Container = styled.div`
    width: 300px;
    height: 300px;
    background-color: ${colorsPalettes.carbon[100]};
`;

const Title = styled.span`
    ${setFontVariant("h5", carbon[500])}
`;

const BoxTitleContainer = styled.div`
    display: flex;
    align-items: center;
`;

export const FixedBoxTitle: FC<IFixedBoxTitle> = ({ title, tooltip }) => {
    return (
        <BoxTitle
            tooltip={tooltip}
            Container={BoxTitleContainer}
        >
            <Title>{title}</Title>
        </BoxTitle>
    );
};
